import React from 'react';
import { Grid, Card, CardContent, CircularProgress, Typography } from '@mui/material';
import Video from '../../Main/Video';
import { useTranslation } from 'react-i18next';
import userService from '../../user.service';
import { refresh, logout } from '../../utils/index';
import NewUserInfo from '../../Main/NewUserInfo';
import { useNavigate } from 'react-router-dom';
import styles from '../../Main/main.styles';
import { makeStyles } from 'tss-react/mui';
import EmergencyButton from '../Components/EmergencyButton';
import useStore, { getUser } from '../../Store/Store';
import SideBar from '../../components/SideBar';

const useStyles = makeStyles()(styles);

const VideoList = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const [videosList, setVideoList] = React.useState([]);
  const width = useStore((state) => state.screenWidth);

  React.useEffect(() => {
    (async () => {
      try {
        setVideoList([
          {
            id: 396084845,
            hash: '99197dbc03',
            instructorName: t('adjust_height'),
          },
          {
            id: 729739706,
            hash: 'b7e6e5893d',
            instructorName: t('how_to_use_cane'),
          },
          {
            id: 396086113,
            hash: '56448cb12a',
            instructorName: t('setup_the_travel_charger'),
          },
          {
            id: 396089810,
            hash: '39e33d0c48',
            instructorName: t('setup_the_wall_charger'),
          },
        ]);
      } catch (e) {
        console.log(e);
      }
    })();
  }, []);

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
        <div>
          <SideBar />
        </div>

        <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
          <NewUserInfo isSideBar={false} />
          <div className="flex-column-a" style={{ left: width > 850 ? '15%' : '0%' }}>
            <h2>{t('howToUseCan')}</h2>
            <Grid style={{ marginTop: '3%' }} container>
              {videosList.map((video) => (
                <Grid style={{ marginBottom: '30px' }} item md={window.screen.width > 900 ? 6 : 12}>
                  <Card
                    style={{
                      backgroundColor: '#FCFAF8',
                      border: 'none',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '400px',
                        position: 'relative',
                      }}
                    >
                      <CircularProgress style={{ position: 'absolute', zIndex: 1, color: '#26786a' }} />
                      <Video style={{ position: 'absolute', zIndex: 2, height: '300px' }} video={video}></Video>
                    </div>

                    <CardContent>
                      <Typography gutterBottom variant="h5" component="div">
                        {video?.instructorName || ''}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {video?.base || ''}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </div>
          <EmergencyButton />
        </div>
      </div>
    </>
  );
};
export default VideoList;
